import type { User } from '@/lib/pos-types'

export const isApiEnabled = () => {
  const viteBase = import.meta.env.VITE_API_BASE_URL
  return typeof viteBase === 'string' && viteBase.trim().length > 0
}

export const getEntryPathForRole = (role: string | null | undefined): string => {
  switch (String(role ?? '')) {
    case 'waiter':
      return '/mesero/mesas'
    case 'cashier':
      return '/caja/ventas'
    case 'admin':
    case 'auditor':
      return '/admin'
    case 'kitchen':
      return '/station/cocina'
    case 'station':
      return '/station/cocina'
    default:
      return '/mesero/mesas'
  }
}

export const getEntryPathForUser = (user: User | null): string => getEntryPathForRole(user?.role)

